<app-guest-auth-main-layout>
  <ng-template>
    <div class="flex items-center p-4">
<!--      <div class="bg-gradient2 move-left cursor-pointer rounded-md p-2" matTooltip="Back">-->
<!--        <span (click)="goBack()">-->
<!--          <strong class="flex justify-center items-center">-->
<!--            <mat-icon svgIcon="back"></mat-icon>-->
<!--          </strong>-->
<!--        </span>-->
<!--      </div>-->
      <div class="font-medium text-lg mx-2">
        {{"Set New Password" |concat|translate }}
      </div>
    </div>

    <div class="">
      <form [formGroup]="form" class="pb-4 px-4 grid grid-cols-1 gap-2">

        <mat-form-field class="col-span-1 w-full" appearance="outline">
          <mat-label>{{"New Password" |concat|translate }}</mat-label>
          <input matInput placeholder='{{"New Password" |concat|translate }}' [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword" />
          <button mat-icon-button matSuffix type="button" (click)="hideNewPassword = !hideNewPassword" tabindex="-1">
            <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('newPassword').hasError('passwordPolicy')">
            {{"Password must be at least 8 characters long, contain uppercase and lowercase letters, a number, and a special character " |concat|translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-span-1 w-full" appearance="outline">
          <mat-label>{{"Confirm Password" |concat|translate }}</mat-label>
          <input matInput placeholder='{{"Confirm Password" |concat|translate }}' [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" />
          <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword" tabindex="-1">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('confirmPassword').value !== form.get('newPassword').value">
            {{"Passwords do not match" |concat|translate }}
          </mat-error>
        </mat-form-field>

        <div class="flex justify-end">
          <button [disabled]="!form.valid" (click)="submitForm(form.value)" mat-raised-button color="primary">
            {{"Save" |concat|translate }}
          </button>
        </div>

      </form>
    </div>
  </ng-template>
</app-guest-auth-main-layout>
